import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import BlogArticleCard from '../BlogArticleCard/BlogArticleCard';
import GenericGalleryGrid from '../GenericGalleryGrid/GenericGalleryGrid';
import useStyles from './BlogArticleListing.styles';
const BlogArticleListing = (props) => {
    const { items, isInspiration, show = true } = props;
    const { classes } = useStyles();
    const breakpoints = {
        extraSmall: 12,
        small: 12,
        medium: 6,
        large: 4,
    };
    return (_jsx("div", { className: show ? classes.show : classes.hide, children: (items === null || items === void 0 ? void 0 : items.length) ? (_jsx(_Fragment, { children: _jsx(GenericGalleryGrid, { breakpoints: breakpoints, ItemComponent: BlogArticleCard, componentProps: { showDescription: true }, initialVisibleItems: isInspiration ? 12 : items === null || items === void 0 ? void 0 : items.length, hasAlgoliaResults: true, items: items, isInspiration: !!isInspiration, className: classes.blogArticleGallery }) })) : (!isInspiration && (_jsx("p", { className: classes.noResults, children: "Sorry there are no articles that match the selected category" }))) }));
};
export default BlogArticleListing;
